import { CLASSROOM_EDIT_FOLDER } from '../actions';
import * as selectors from '../selectors';
import { patchFolder } from '../api';

const editFolderAction = (status, payload) => ({
  type: CLASSROOM_EDIT_FOLDER,
  status,
  payload,
});

const editFolderStarted = editFolderAction.bind(null, 'started');
const editFolderSuccess = editFolderAction.bind(null, 'success');
const editFolderError = editFolderAction.bind(null, 'error');

const editFolder = (folderId, patch) => async (dispatch, getState) => {
  const state = getState();
  const oldFolder = selectors.getMaterial(state, folderId);

  if (!oldFolder) {
    return;
  }

  dispatch(editFolderStarted({ materialId: folderId }));

  try {
    const updatedFolder = await patchFolder(oldFolder.space, folderId, patch);
    dispatch(editFolderSuccess({ updatedMaterial: updatedFolder }));
  } catch (error) {
    dispatch(editFolderError({ error }));
  }
};

export default editFolder;
